import { Dialog, TextField } from "@mui/material";
import { useState } from "react";
import {
  defValueFuncao,
  TFuncaoFinanceiro,
} from "../../types/api/financeiro/funcoes-financeiro";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";

export default function SelectFuncoes({
  value,
  onChange,
  required = false,
  error = false,
  possuiBtnLimpar = false,
  multiple = false,
  extraParams = {}
}: SelectSimpleApiQueryProps) {
  const [openModal, setOpenModal] = useState(false);

  const handleClose = () => setOpenModal(false);

  const inputLabel = (() => {
    if (!value) return "";
    if (Array.isArray(value)) {
      return value.map((item) => item.id).join(", ");
    } else {
      return `${value.id ?? ""}${value.nome ? ` - ${value.nome}` : ""}`;
    }
  })();

  return (
    <>
      <TextField
        {...{ required, error }}
        label={`Função`}
        variant="outlined"
        fullWidth
        onClick={() => setOpenModal(true)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setOpenModal(true);
          }
        }}
        slotProps={{
          input: { readOnly: true }
        }}
        value={inputLabel}
        helperText={error ? "Campo obrigatório" : ""}
      />

      {openModal && (
        <Dialog fullWidth maxWidth="sm" open={openModal} onClose={handleClose}>
          <DialogContentSelectGeneric
            {...{ handleClose, possuiBtnLimpar, multiple, extraParams }}
            title="Selecionar função"
            queryPath="/financeiro/configuracoes/pesquisar-funcoes"
            getItemKey={(item) => item.id}
            defaultValue={
              multiple
                ? Array.isArray(value) && value.length > 0
                  ? value
                  : [defValueFuncao]
                : value
                  ? value
                  : defValueFuncao
            }
            getItemLabel={(item) => `${item.id} - ${item.nome}`}
            onChange={(value) => {
              onChange(value as TFuncaoFinanceiro);
              handleClose();
            }}
          />
        </Dialog>
      )}
    </>
  );
}

interface SelectSimpleApiQueryProps {
  value: TFuncaoFinanceiro | TFuncaoFinanceiro[];
  onChange: (arg: TFuncaoFinanceiro | null) => void;
  required?: boolean;
  error?: boolean;
  possuiBtnLimpar?: boolean;
  multiple?: boolean;
  extraParams?: { [key: string]: any };
}
